<div style="padding: 10px;">
<div [formGroup]="form">
  <h1 style="text-align: center;">{{data.title}}</h1>
  <mat-form-field class="input-section">
    <input matInput type="text" [placeholder]="data.placeholder || 'Value'" formControlName="value" />
  </mat-form-field>
</div>
<div style="margin-top: 10px; width: 100%; display: flex; justify-content: center; gap: 10px;">
  <button mat-raised-button (click)="onClose(true);">{{data.yes || 'Confirm'}}</button>
  <button mat-raised-button (click)="onClose(false);">{{data.no || 'Cancel'}}</button>
</div>
</div>